import React from "react";

function Barber() {
  return (
    <main>
        <section className="hero">
            <div>
            <h1>Barbers</h1>
            <p>Find the best barbers in your area!</p>
            </div>
        </section>
    </main>
  );
}

export default Barber;
